import * as api from '../api';
import {GET_ALL,INSERT} from '../constants/actionTypes';

export const getHomePageContent = ()=> async (dispatch)=> {
    
    try {
        const {data} = await api.fetchHomepagePosts();
        
        dispatch({type:GET_ALL,payload: data});
    } catch (error) {
        console.log(error.message);
    }

}
export const createHomePost = (PagePostData) => async (dispatch) =>{
    try {
        const {data} = await api.createHomePagePosts(PagePostData);

        dispatch({type:INSERT,payload: data})
    } catch (error) {
        console.log(error);
    }
}